import { cx } from '@lastbrand/web-ui-styled-system/css'

import { FormattedPrice } from '@src/blocks/currency/currency.component'

import * as styles from './product-info-price-ds.styles'

export interface MainPriceColumnProps {
  formattedSalePrice: string
  formattedTraditionalPrice?: string
  formattedFestivalOfferPrice?: string
  isSubscriptionOffer: boolean
  isB2BFinalSaleProduct?: boolean
  updatedDesignForV2?: boolean
  hasPerUnitPricing: boolean
  unitForPerServing: string
  pricePerServing?: number
  traditionalPricePerServing?: number
  earnCreditTagFor3PVendor?: string
}

function MainPriceColumn({
  formattedSalePrice,
  formattedTraditionalPrice,
  formattedFestivalOfferPrice,
  isSubscriptionOffer,
  isB2BFinalSaleProduct,
  updatedDesignForV2,
  hasPerUnitPricing,
  unitForPerServing,
  pricePerServing,
  traditionalPricePerServing,
  earnCreditTagFor3PVendor,
}: MainPriceColumnProps) {
  const isOfferRow = !!formattedFestivalOfferPrice || isSubscriptionOffer

  return (
    <div
      className={cx(
        styles.priceWrapperMainValueCss,
        isOfferRow ? styles.priceWrapperMainValueQpOfferCss : styles.priceWrapperMainValueQpCss,
        isOfferRow && styles.priceWrapperMainValueQpOfferOriginalCss,
        isB2BFinalSaleProduct && !formattedTraditionalPrice && styles.b2bPriceWrapperCss,
        updatedDesignForV2 && styles.priceWrapperMainValueQpUpdatedDesignV2Css,
      )}
    >
      <span className="sales_price_selector_for_force_update">
        <FormattedPrice amount={formattedSalePrice} />
      </span>
      {hasPerUnitPricing && !formattedFestivalOfferPrice && !isSubscriptionOffer && unitForPerServing && (
        <span className={cx(styles.priceWrapperMainValuePerservingCss)}>
          {'('}
          <span className={cx(styles.priceWrapperMainValuePerservingTraditionalCss)}>
            <FormattedPrice amount={traditionalPricePerServing} />{' '}
          </span>
          <FormattedPrice amount={pricePerServing} />/{unitForPerServing}
          {')'}
        </span>
      )}
      {earnCreditTagFor3PVendor && !formattedFestivalOfferPrice && (
        <div className={styles.priceWrapperMainEarnCreditTagCss}>{earnCreditTagFor3PVendor}</div>
      )}
    </div>
  )
}

export default MainPriceColumn
